import Entity from './Entity';
import config from '../common/config';

function Platform(img, x = 0, y = 0, dx = 0, dy = 0) {
    Entity.apply(this, arguments);
    this.width = config.platformWidth;
    this.height = config.platformHeight;
    this.dx = -config.platformSpeed;
}

function getSprite() {
    return {
        image: this.image,
        dx: this.x,
        dy: this.y,
    };
}

function update() {
    this.move();
}

Platform.prototype = Object.create(Entity.prototype);
Platform.prototype.constructor = Platform;
Platform.prototype.getSprite = getSprite;
Platform.prototype.update = update;

export default Platform;
